// HTWK
export const HTWK_YELLOW = "#ffed00" as const;
export const HTWK_YELLOW_TRANSPARENT = "#333000" as const;
export const HTWK_YELLOW_HOVER = "#ffed0077" as const;
export const HTWK_MAGENTA = "#e5007d" as const;
export const HTWK_RED = "#e53009" as const;
export const HTWK_GREEN = "#00964e" as const;
export const HTWK_CYAN = "#009ee3" as const;
export const HTWK_BLUE = "#004699" as const;
export const HTWK_LIGHT_GRAY = "#bec3c6" as const;
export const HTWK_GRAY = "#2e3639" as const;
export const HTWK_DARK_BLUE = "#022541" as const;
export const HTWK_LIGHT_TEXT = "#ffffff" as const;
export const HTWK_DARK_TEXT = "#000000" as const;

// Other
export const HTWKALENDER_GRAY = "#1b2022";

// Room-Colors
export const ROOM = "#454c7f" as const;
export const ROOM_HIGHLIGHTED = "#6e79cb" as const;
export const ROOM_SEARCHED = "#aaad39" as const;
export const ROOM_INACTIVE = "#8388a9" as const;
export const TOILET = "#0ec3b8" as const;
export const ELEVATOR = "#4c5a5f" as const;
export const STAIRS = "#4c5a5f" as const;
export const WALL = HTWK_LIGHT_GRAY;
export const CAMPUS = "#4c5a5f" as const;

// LVB
export const LEIPZIG_YELLOW = "#ffcc00" as const;
export const LEIPZIG_RED = "#e30613" as const;
export const LEIPZIG_PURPLE = "#a71681" as const;
export const LEIPZIG_WHITE_TEXT = "#ffffff" as const;
export const LEIPZIG_BLACK_TEXT = "#1d1d1b" as const;

// HTWKarte
export const BOX_COLOR = "#495079"; // ROOM + "dd";
